export function hasRole(user, roles) {
  if (!user) return false;
  if (!roles) return true;
  if (typeof roles === 'string') roles = [roles];
  return roles.includes(user.role);
}

export function isSuperadmin(user) {
  return user?.role === 'superadmin';
}
